import script from "./AddEditInterestRateView.vue?vue&type=script&setup=true&lang=js"
export * from "./AddEditInterestRateView.vue?vue&type=script&setup=true&lang=js"

import "./AddEditInterestRateView.vue?vue&type=style&index=0&id=6c0e37e7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c0e37e7"]])

export default __exports__